import { render, staticRenderFns } from "./evaStatistics.vue?vue&type=template&id=4ec06864&scoped=true&"
import script from "./evaStatistics.vue?vue&type=script&lang=js&"
export * from "./evaStatistics.vue?vue&type=script&lang=js&"
import style0 from "./evaStatistics.vue?vue&type=style&index=0&id=4ec06864&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec06864",
  null
  
)

export default component.exports